import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class EllipseBorder extends AbstractProvidedClass {
    defaultTolerance = 10;

    constructor(provider, parent, center) {
        super(provider);
        this.parent = parent;
        this.center = center;
    }

    hovered() {
        let dist = this.center.currentDistanceTo(this.view.coordinate);
        return Math.abs(dist - this.parent.currentSize / 2) <= Math.min(this.defaultTolerance, this.parent.currentSize / 10);
    }

    drag(dx, dy) {
        this.move(dx, dy);
    }

    move(dx, dy) {
        this.parent.size = this.center.absDistanceTo(this.view.snappedCoordinate) * 2;
        this.getTab('info').input.size.value(this.calculatePixelToDisplayDistance(this.parent.size));
    }

    mouseOver() {
        if (!this.hovered()) {
            return false;
        }

        let angle = this.center.angleTo(this.view.coordinate);
        this.cursor.resizeAngle(angle);
        return true;
    }
}
